module.exports = __webpack_public_path__ + "static/media/portugal.d04dba23.svg";